import Cookies from 'js-cookie';
import { I18N } from './auth';
import { enGB, it } from 'date-fns/locale';

const getBrowserLanguage = () => {
  const language = navigator.language.split(/[-_]/)[0].toLowerCase();
  return language === 'it' || language === 'en' ? language : 'en';
};

export const userLanguage =
  Cookies.get(I18N) === 'it' || Cookies.get(I18N) === 'en'
    ? Cookies.get(I18N)
    : getBrowserLanguage();

export const getUserLocale = () => {
  if (userLanguage === 'it') {
    return it;
  }
  return enGB;
};

export const getDayJsLocale = () => {
  if (userLanguage === 'it') {
    return 'it';
  }
  return 'en';
};
